import { useLazyQuery, useMutation } from "@apollo/client";
import { useContext, useEffect, useState } from "react";
import ReportContext from "../../../context/ReportsContext/ReportContext";
import { CREATE_GRAPH, GET_CUSTOMDATAREPORT,  GET_DATAREPORTS } from "../../../Querys/reports/querys";
import { clearReportsModal } from "../../../context/ReportsContext/Actions";
import { renamePropertiesSpanish } from "../../../helpers/renamePropertiesSpanish";
import AddTable from "../../../screens/Colaboradores/Colaboradores/CollaboratorTab/AddTable";
import styles from "../css/CreateReports.module.css";
import { useFormik } from "formik";
import ExtraFileds from "../components/ExtraFileds";
import * as Yup from "yup";
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { Dialog, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";

const graphs = [
  { id: 'histogram', value: 'histogram', label: 'Histograma' },
  { id: 'lollipop', value: 'lollipop', label: 'Piruleta' },
  { id: 'pie', value: 'pie', label: 'Pastel' },
  { id: 'donut', value: 'donut', label: 'Dona' },
  { id: 'circularBar', value: 'circularBar', label: 'Circular' },
  { id: 'density', value: 'density', label: 'Densidad' },
  { id: 'rid', value: 'rid', label: 'Ridgeline' },
  { id: 'box', value: 'box', label: 'Caja' }
  /*{ id: 'scatter', value: 'scatter', label: 'Dispersión' },
  { id: 'density2d', value: 'density2d', label: 'Hexbin' }*/
];

const CreateGraph = ({ reports, refetch }: any) => {
  const { state, dispatch } = useContext(ReportContext);
  const { adminState } = useContext(AdminContext)
  const [reportTypeId, setReportTypeId] = useState<string[]>([]);
  const [reportColumns, setReportColumns] = useState<string[]>([]);
  const [reportContent, setReportContent] = useState<Array<any>>([]);
  const [getReportSingle] = useLazyQuery(GET_DATAREPORTS);
  const [getCustomReportSingle] = useLazyQuery(GET_CUSTOMDATAREPORT);
  const [createGraph] = useMutation(CREATE_GRAPH);
  
  const formik = useFormik({
    initialValues: {
      graphName: '',
      report: '',
      graph: '',
      ejex: '',
      ejey: '',
      rangoxmin: '',
      rangoxmax: '',
      rangoymin: '',
      rangoymax: ''
    },
    validationSchema: Yup.object({
      graphName: Yup.string().required("Obligatorio"),
      report: Yup.string().required("Es necesario seleccionar el informe"),
      graph: Yup.string().required('Es necesario seleccionar el gráfico a crear'),
      ejex: Yup.string().required('Es necesario seleccionar los datos que estarán en la serie')
        .notOneOf([Yup.ref('ejey'), null], 'No se puede usar la misma serie de datos'),
      rangoxmax: Yup.string().when('graph', {
        is: (graph: string) => ["density", "rid", "box", ].includes(graph),
        then: Yup.string().required('Es necesario establecer el valor máximo en la serie')
          .matches(/^(-[1-9]\d*|0)$|^[^-]*$/, 'Esto no es válido')
          .test('menory', 'El máximo no puede ser menor o igual que el mínimo', function (value) {
            if (value && this.parent.rangoxmin) {
              const menor = parseInt(this.parent.rangoxmin);
              const val2 = parseInt(value);
              return menor < val2;
            }
            return true;
          })
      }),
      rangoxmin: Yup.string().when('graph', {
        is: (graph: string) => ["density", "rid", "box"].includes(graph),
        then: Yup.string().required('Es necesario establecer el valor mínimo en la serie')
          .matches(/^(-[1-9]\d*|0)$|^[^-]*$/, 'Esto no es válido')
          .test('mayorx', 'El mínimo no puede ser mayor o igual que el máximo', function (value) {
            if (value && this.parent.rangoxmax) {
              const mayor = parseInt(this.parent.rangoxmax);
              const val2 = parseInt(value);
              return mayor > val2;
            }
            return true;
          })
      }),
      ejey: Yup.string().when('graph', {
        is: (graph: string) => ["rid", "box",].includes(graph),
        then: Yup.string().required('Es necesario seleccionar los datos que estarán en la serie')
          .notOneOf([Yup.ref('ejex'), null], 'No se puede usar la misma serie de datos'),
      }),
      /*rangoymax: Yup.string().when('graph', {
        is: (graph: string) => ["scatter", "density2d"].includes(graph),
        then: Yup.string().required('Es necesario establecer el valor máximo en la serie')
          .matches(/^(-[1-9]\d*|0)$|^[^-]*$/, 'Esto no es válido')
          .test('menory', 'El máximo no puede ser menor o igual que el mínimo', function (value) {
            if (value && this.parent.rangoymin) {
              const menor = parseInt(this.parent.rangoymin);
              const val2 = parseInt(value);
              return menor < val2;
            }
            return true;
          })
      }),
      rangoymin: Yup.string().when('graph', {
        is: (graph: string) => ["scatter", "density2d"].includes(graph),
        then: Yup.string().required('Es necesario establecer el valor mínimo en la serie')
          .matches(/^(-[1-9]\d*|0)$|^[^-]*$/, 'Esto no es válido')
          .test('mayory', 'El mínimo no puede ser mayor o igual que el máximo', function (value) {
            if (value && this.parent.rangoymax) {
              const mayor = parseInt(this.parent.rangoymax);
              const val2 = parseInt(value);
              return mayor > val2;
            }
            return true;
          })
      }),*/
    }),
    enableReinitialize: true,
    onSubmit: async (formData, { resetForm }) => {
      //console.log("submit", formData);
      //console.log('Frecuency data', calculateColumnFrequency(reportContent, formik.values.ejex))
      //console.log("Only the number", extractColumnWithDefault(reportContent,formik.values.ejex))
      let DataTreat : any
      
      switch (formData.graph) {
        case 'histogram':
        case 'lollipop':
        case 'pie':
        case 'donut':
        case 'circularBar':
            DataTreat = calculateColumnFrequency(reportContent, formData.ejex)
            break;
        case 'density':
            DataTreat = extractColumnWithDefault(reportContent,formData.ejex)
            break;
        case 'rid':
            DataTreat = ridData(reportContent,formData.ejey,formData.ejex)
            break;
        case 'box':
            const num = extractColumnAsObjects(reportContent, formData.ejex, 'value');
            const name = extractColumnAsObjects(reportContent, formData.ejey, 'name', 'SIN_DATOS')
            DataTreat = combineArrays(name,num, 'name', 'value')
            break;
        /*case 'scatter':
        case 'density2d':
          const x = extractColumnAsObjects(reportContent, formData.ejex, 'x');
          const y = extractColumnAsObjects(reportContent, formData.ejey, 'y')
          DataTreat =  combineArrays(x, y,'x','y',2);
          break;*/
        default:
           break;; // or some default component if needed
      }
      const DataJson = JSON.stringify(DataTreat);
       
       await createGraph({
        variables:{
          input:{
            name: formData.graphName,
            graphType: formData.graph,
            informe: formData.report,
            userName: adminState?.Usuario,
            xLimMax: formData.rangoxmax === '' ? null : formData.rangoxmax,
            xLimMin: formData.rangoxmin === '' ? null : formData.rangoxmin,
            yLimMax: formData.rangoymax === '' ? null : formData.rangoymax,
            yLimMin: formData.rangoymin === '' ? null : formData.rangoymin,
            dataToGraph: DataJson
          }
        }
       })
       refetch();
      //console.log('%cElementoForm',"color:yellow",formData)
      resetForm();
      setReportTypeId([]);
      setReportContent([]);
      setReportColumns([]);
      clearReportsModal(false, dispatch);
      
      SuccessfulAlert({ text: "Se ha creado el gráfico correctamente" });
    }
  });

  useEffect(() => {
    if (reportTypeId.length > 0) {
      const type = reportTypeId[0];
      const id = reportTypeId[1];

      if (type === 'Personalizado') {
        getReportCustom(id);
      } else {
        getReportNotCustom(id);
      }
    }
  }, [reportTypeId]);

  const closeModal = () => {
    clearReportsModal(false, dispatch);
    formik.resetForm();
    setReportTypeId([]);
    setReportContent([]);
    setReportColumns([]);
  };

  const handleChangeSelectInforme = (event: any) => {
    const str = event.target.value as string;
    setReportTypeId(str.split(','));
    formik.setValues({
      ...formik.values,
      report: str,
      ejex: '',
      ejey: '',
      rangoxmax: '',
      rangoxmin: '',
      rangoymax: '',
      rangoymin: ''
    });
  };

  const handleChangeSelectGraph = (event: any) => {
    const str = event.target.value as string;
    formik.setValues({
      ...formik.values,
      graph: str,
      ejex: '',
      ejey: '',
      rangoxmax: '',
      rangoxmin: '',
      rangoymax: '',
      rangoymin: ''
    });
    formik.setTouched({
      ...formik.touched,
      ejex: false,
      ejey: false,
      rangoxmax: false,
      rangoxmin: false,
      rangoymax: false,
      rangoymin: false
    }, false);
    
  };

  const getReportNotCustom = async (id: any) => {
    const { data } = await getReportSingle({ variables: { getDatareportsId: id } });
    if (data?.GET_DATAREPORTS?.length > 0) {
      const reportJson = renamePropertiesSpanish(JSON.parse(data.GET_DATAREPORTS));
      setReportColumns(Object.keys(reportJson[0]));
      setReportContent(reportJson);
    }
  };

  const getReportCustom = async (id: any) => {
    const { data } = await getCustomReportSingle({ variables: { getDatareportsId: id } });
    if (data?.GET_CUSTOMDATAREPORT?.length > 0) {
      const reportJson = JSON.parse(data.GET_CUSTOMDATAREPORT);
      setReportColumns(Object.keys(reportJson.query[0]));
      setReportContent(reportJson.query);
    }
  };

  return (
    <Dialog
    open={state.createModalGraph}
    fullWidth
    >
      <div className={styles.mainBox}>
        <div className={styles.mainContainer}>
          <button
            className={styles.closeModalButton}
            onClick={closeModal}
          >
            <img src="/../../../assets/svg/CloseM.svg" />
          </button>
        </div>
        <h2 id="form-dialog-title" className="text-center">
          Crear Gráfico
        </h2>

        <form onSubmit={formik.handleSubmit}>
          <TextField
           type="text"
           name="graphName"
           label="Nombre del gráfico*"
           variant="outlined"
           size="small"
           fullWidth
           onBlur={formik.handleBlur}
           onChange={formik.handleChange}
           value={formik.values.graphName}
           error={formik.touched.graphName && Boolean(formik.errors.graphName)}
           helperText={formik.touched.graphName && formik.errors.graphName}
           inputProps={{ maxLength: 50 }}
          />

          <div className={styles.formControlContainer}>
            <FormControl
              size="small"
              variant="outlined"
              style={{ width: '48%' }}
            >
              <InputLabel id="Informe-label" className={styles.formLabel}>Informe*</InputLabel>
              <Select
                onChange={handleChangeSelectInforme}
                value={formik.values.report}
                labelId="Informe-label"
                label='Informe*'
                id="Informe"
                name="Informe"
                error={formik.touched.report && Boolean(formik.errors.report)}             
              >
                {reports?.map((item: any) => (
                  <MenuItem key={`${item.id}${item.ReportName}Select`} value={`${item.ReportType},${item.id}`}>
                    {item.ReportName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText style={{ color: "red" }}>
                {formik.touched.report && formik.errors.report}
              </FormHelperText>
            </FormControl>

            <FormControl
              size="small"
              variant="outlined"
              style={{ width: '48%' }}
            >
              <InputLabel id="grafico-label" className={styles.formLabel}>
                Gráfico*
              </InputLabel>
              <Select
                onChange={handleChangeSelectGraph}
                value={formik.values.graph}
                labelId="grafico-label"
                id="grafico"
                name="grafico"
                label="Gráfico*"
                error={formik.touched.graph && Boolean(formik.errors.graph)}
              >
                {graphs.map((item) => (
                  <MenuItem key={item.id} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText style={{ color: "red" }}>
                {formik.touched.graph && formik.errors.graph}
              </FormHelperText>
            </FormControl>
          </div>

          {formik.values.graph !== '' && (
            <ExtraFileds graph={formik.values.graph} reportColumns={reportColumns} formik={formik} firstRow={reportContent[0]} />
          )}

          <div className={styles.formControlContainer} style={{ justifyContent: 'space-evenly' }}>
            <button className={styles.cancelButton} type="button" onClick={closeModal}>
              Cancelar
            </button>
            <AddTable func={() => console.log('func')} text="Generar gráfico" img="report-icon.svg" type="submit" />
          </div>
        </form>
      </div>
    </Dialog>
  );
};


interface DataRow {
  [key: string]: any;
}

interface ColumnFrequency {
  name: string;
  value: number;
}

function calculateColumnFrequency(data: DataRow[], column: string): ColumnFrequency[] {
  const frequencyMap: { [key: string]: number } = {};

  data.forEach((row: DataRow) => {
    const value = row[column];
    if (value !== undefined) {
      if (frequencyMap[value]) {
        frequencyMap[value] += 1;
      } else {
        frequencyMap[value] = 1;
      }
    }
  });

  return Object.keys(frequencyMap).map((key) => ({
    name: key === 'null' ? 'SIN_DATOS' : key,
    value: frequencyMap[key],
  }));
}
function extractColumnWithDefault(data: DataRow[], column: string, defaultValue: any = 0): any[] {
  return data.map(row => row[column] !== undefined && row[column] !== null ? row[column] : defaultValue);
}

function extractColumnAsObjects(data: DataRow[], column: string, prop: string, defaultValue: any = 0): { [key: string]: any }[] {
  return data.map(row => {
    const value = row[column] !== undefined && row[column] !== null ? row[column] : defaultValue;
    return { [prop]: value };
  });
}

function combineArrays(array1: string | any[], array2: string | any[], propArr1: string | number, propArr2: string | number, opt: number  = 1) {
  const maxLength = Math.max(array1.length, array2.length);
  const combinedArray = [];

  if(opt !== 1){
    for (let i = 0; i < maxLength; i++) {
      combinedArray.push({
        x: array1[i][propArr1] ?? 0,
        y: array2[i][propArr2] ?? 0,
      });
    }
  
    return combinedArray;
  }
  
  for (let i = 0; i < maxLength; i++) {
    combinedArray.push({
      name: array1[i][propArr1] || 'SIN_DATOS',
      value: array2[i][propArr2] ?? 0,
    });
  }
  return combinedArray;
}

function ridData(data: any[], colString: string , colNum: string) {
  const uniqueNames = [...new Set(data.map(item => item[colString]))];
  
  const dataRid = uniqueNames.map((key) => ({
    key: key,
    values: data
      .filter(item => item[colString] === key)
      .map(item => item[colNum] === null ? 0 :  item[colNum]),
  }));
  
  return dataRid;
}

export default CreateGraph;